export const COLOR_PRIMARY = '#FF5500';
export const COLOR_GRAY = '#ffffff'
export const COLOR_RED = '#EF4444';
export const COLOR_BLUE = '#0055FF';
export const COLOR_PURPLE = '#950BEA';
export const COLOR_GREEN = '#16A34A';
export const COLOR_DARKGRAY = '#959595';
export const COLOR_YELLOW = '#FFD051';
export const COLOR_ORANGE = '#FF873D';
export const COLOR_DARK_BORDER = 'rgba(255, 255, 255, 0.12)';